export default __webpack_public_path__ + "static/media/logo_footer_1.dadf4a16.svg";